import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "licenceCheckFilled"
const LicenceCheckFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M21.44 13.875 22.5 14.782 22.939 15.158 16.326 22.875 11.625 18.175 13.02 16.778 16.214 19.972z" />
          <path
            fillRule="evenodd"
            d="M21 3.75C21.828 3.75 22.5 4.422 22.5 5.25V12.183L21.227 11.093 16.102 17.07 13.02 13.989 11.26 15.75H5.25C4.836 15.75 4.5 16.086 4.5 16.5S4.836 17.25 5.25 17.25H9.759L8.834 18.174 10.91 20.25H3C2.172 20.25 1.5 19.578 1.5 18.75V5.25C1.5 4.422 2.172 3.75 3 3.75zM5.25 6.75C4.862 6.75 4.542 7.045 4.504 7.423Q4.5 7.461 4.5 7.5V12.75L4.504 12.827Q4.51 12.896 4.53 12.96 4.545 13.016 4.57 13.067L4.58 13.084Q4.603 13.134 4.634 13.179L4.645 13.193Q4.716 13.285 4.807 13.353L4.82 13.365Q4.865 13.397 4.915 13.42L4.932 13.43Q4.983 13.453 5.038 13.469 5.104 13.49 5.173 13.496L5.25 13.5H10.5L10.577 13.496Q10.652 13.49 10.722 13.466 10.728 13.466 10.732 13.463 10.76 13.454 10.787 13.443 10.8 13.439 10.813 13.43L10.853 13.411 10.867 13.401Q10.891 13.39 10.911 13.377L10.934 13.361 10.972 13.332 10.983 13.322 11.023 13.287 11.036 13.272Q11.077 13.23 11.112 13.182L11.128 13.158Q11.158 13.114 11.18 13.064 11.216 12.986 11.235 12.901L11.24 12.857Q11.25 12.805 11.25 12.75V7.5C11.25 7.086 10.914 6.75 10.5 6.75zM13.5 10.125C13.086 10.125 12.75 10.461 12.75 10.875S13.086 11.625 13.5 11.625H17.25C17.664 11.625 18 11.289 18 10.875S17.664 10.125 17.25 10.125zM13.5 7.5C13.086 7.5 12.75 7.836 12.75 8.25S13.086 9 13.5 9H18.75C19.164 9 19.5 8.664 19.5 8.25S19.164 7.5 18.75 7.5z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default LicenceCheckFilledIcon
